import {
  REQUEST_USER_DETAILS,
  SUCCESS_USER_DETAILS,
  REQUEST_USER_REMOVE,
  SUCCESS_USER_REMOVE,
  REQUEST_USER_ADD,
  SUCCESS_USER_ADD,
  REQUEST_USER_EDIT,
  SUCCESS_USER_EDIT,
  REQUEST_USER_BYID,
  SUCCESS_USER_BYID,
  REQUEST_ALL_USER_DETAILS,
  SUCCESS_ALL_USER_DETAILS,
  REQUEST_ATTENDANCE_ADD,
  SUCCESS_ATTENDANCE_ADD,
  REQUEST_ATTENDANCE_GET,
  SUCCESS_ATTENDANCE_GET,
} from "./../../constants/ActionTypes";

export const requestUserDetails = (data) => {
  return {
    type: REQUEST_USER_DETAILS,
    payload: data,
  };
};

export const successUserDetails = (data) => {
  return {
    type: SUCCESS_USER_DETAILS,
    payload: data,
  };
};

export const requestAllUserDetails = (data) => {
  return {
    type: REQUEST_ALL_USER_DETAILS,
    payload: data,
  };
};

export const successAllUserDetails = (data) => {
  return {
    type: SUCCESS_ALL_USER_DETAILS,
    payload: data,
  };
};

export const requestUserRemove = (data) => {
  return {
    type: REQUEST_USER_REMOVE,
    payload: data,
  };
};

export const successUserRemove = (data) => {
  return {
    type: SUCCESS_USER_REMOVE,
    payload: data,
  };
};

export const requestUserAdd = (data) => {
  return {
    type: REQUEST_USER_ADD,
    payload: data,
  };
};

export const successUserAdd = (data) => {
  return {
    type: SUCCESS_USER_ADD,
    payload: data,
  };
};

export const requestUserEdit = (data) => {
  return {
    type: REQUEST_USER_EDIT,
    payload: data,
  };
};

export const successUserEdit = (data) => {
  return {
    type: SUCCESS_USER_EDIT,
    payload: data,
  };
};

export const requestUserDetailById = (id) => {
  return {
    type: REQUEST_USER_BYID,
    payload: id,
  };
};

export const successUserDetailById = (data) => {
  return {
    type: SUCCESS_USER_BYID,
    payload: data,
  };
};

// Attendance Actions

export const requestAttendanceAdd = (data) => {
  return {
    type: REQUEST_ATTENDANCE_ADD,
    payload: data,
  };
};

export const successAttendanceAdd = (data) => {
  return {
    type: SUCCESS_ATTENDANCE_ADD,
    payload: data,
  };
};

export const requestAttendanceGet = (data) => {
  return {
    type: REQUEST_ATTENDANCE_GET,
    payload: data,
  };
};

export const successAttendanceGet = (data) => {
  return {
    type: SUCCESS_ATTENDANCE_GET,
    payload: data,
  };
};
